import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { MobileCrashreport } from './mobilecrashreport.page';
export const routes: Routes = [
    { path: 'serverlogreport', component: MobileCrashreport }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        MobileCrashreport
    ]
})
export class MobileCrashreportModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/mobilecrashreport/mobilecrashreport.module.ts